import { useQuery } from 'react-query'
import { ApiService } from 'src/services/api.service'

export const STANDING_CONSENT_ACCEPTANCE_HINTS_KEY = 'standing-consent-acceptance-hints'

export function useStandingConsentAcceptanceHints(phones: string[], enabled: boolean) {
  const normalizedPhones = [...new Set(phones.filter(Boolean))].sort().join(',')

  return useQuery(
    [STANDING_CONSENT_ACCEPTANCE_HINTS_KEY, normalizedPhones],
    () => ApiService.PhoneStandingConsents.getAcceptanceHints(phones),
    {
      enabled: enabled && phones.length > 0,
      staleTime: 60_000,
    },
  )
}
